import {LOGIN_SUCCESS, LOGOUT,USER_RELOAD_SUCCESS, REFRESH_TOKEN_SUCCESS} from './actions'

let user = JSON.parse(localStorage.getItem('user'));
const emptyState = {
    loggedIn: false,
    user: {
        id: null,
        name: '',
        email: null,
        token: null,
        permissions: []
    }
};
const initialState = user ? {
    loggedIn: true,
    user
} : emptyState;

// -----------------------------------------------------------------------------
// REDUCER

export default (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_SUCCESS:
            return {
                ...state,
                loggedIn: true,
                user: action.user.data
            };
        case USER_RELOAD_SUCCESS:
        case REFRESH_TOKEN_SUCCESS:
            return {
                ...state,
                user: action.user.data
            };
        case LOGOUT:
            return emptyState;
        default:
            return state
    }
}

// -----------------------------------------------------------------------------
// PRIVATE SELECTORS

export function isLoggedIn(store) {
    return store.loggedIn
}

export function getToken(store){
    return store.user.token
}

export function isAdmin(store){
    return hasPermission(store,'admin')
}

export function hasPermission(store, permission){
    if(typeof store.user.permissions === 'undefined'){
        return false;
    }
    for(let i in store.user.permissions){
        if(typeof store.user.permissions[i] === 'undefined'){
            continue;
        }
        if(store.user.permissions[i].name === permission){
            return true;
        }
        if(store.user.permissions[i].name === 'admin'){
            return true;
        }
    }
    return false;
}

export function getUser(store) {
    return store.user
}



// WEBPACK FOOTER //
// ./src/data/user/reducer.js